/**
 * Decorator Factory
 *
 * Factory class for creating zone-specific platform decorators
 * Maps zone IDs (1-6) to their corresponding decorator implementations
 */

import Phaser from 'phaser';
import { SurfaceType } from '@/config/constants';
import { SeededRandom } from '@/utils/SeededRandom';
import { PlatformDecoratorBase } from './PlatformDecoratorBase';
import { Zone1Decorator } from './Zone1Decorator';
import { Zone2Decorator } from './Zone2Decorator';
import { Zone3Decorator } from './Zone3Decorator';
import { Zone4Decorator } from './Zone4Decorator';
import { Zone5Decorator } from './Zone5Decorator';
import { Zone6Decorator } from './Zone6Decorator';

export class DecoratorFactory {
  /**
   * Create a zone-specific decorator instance
   *
   * @param scene - Phaser scene for graphics creation
   * @param zoneId - Zone identifier (1-6)
   * @param surfaceType - Surface type for decoration filtering
   * @param random - Seeded random number generator
   * @returns Zone-specific decorator instance
   */
  public static createDecorator(
    scene: Phaser.Scene,
    zoneId: number,
    surfaceType: SurfaceType,
    random: SeededRandom
  ): PlatformDecoratorBase {
    switch (zoneId) {
      case 1:
        return new Zone1Decorator(scene, surfaceType, random);
      case 2:
        return new Zone2Decorator(scene, surfaceType, random);
      case 3:
        return new Zone3Decorator(scene, surfaceType, random);
      case 4:
        return new Zone4Decorator(scene, surfaceType, random);
      case 5:
        return new Zone5Decorator(scene, surfaceType, random);
      case 6:
        return new Zone6Decorator(scene, surfaceType, random);
      default:
        console.warn(`Unknown zoneId: ${zoneId}, defaulting to Zone 1 decorator`);
        return new Zone1Decorator(scene, surfaceType, random);
    }
  }
}
